module.exports = __webpack_public_path__ + "shape1.b986fe6a0c6b736f3d7d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/assets/images/tooltip/shape1.svg
// module id = ../../../../../src/assets/images/tooltip/shape1.svg
// module chunks = styles